<template>
	<div v-if="loaded">
		<module-metaseo
				:data-update-role="userRoles.includes('provider_types.update')">
			<template v-slot:custom-text>
				<p>Here you can edit the SEO/Metadata of the {{ providerType.translations['en'].name }} hubpage</p>
			</template>
		</module-metaseo>
	</div>
</template>

<script>
	import {eventBus} from "../../../app";

	export default {
		props: {
			dataProviderTypeId: {
				type: Number
			}
		},
		data() {
			return {
				providerTypeId: this.dataProviderTypeId,
				tabName: 'providerTypeMetaSeoContainer',
				loaded: false,
				providerType: {},
				userRoles: this.$currentUserRoles
			}
		},
		mounted() {
			this.fetchDataFromApi();
		},
		methods: {
			fetchDataFromApi: function () {
				let vm = this;
				eventBus.$emit('onLoaderStart');
				axios.post('/api/' + vm.$selectedSite.slug + '/providertype/fetchtabdata/' + vm.providerTypeId, {
					tab: vm.tabName
				})
					.then(response => {
						if (response.data.hasOwnProperty('data')) {
							if (response.data.data.hasOwnProperty('providerType')) {
								vm.providerType = response.data.data.providerType;
							}
							if (response.data.data.hasOwnProperty('allProviders')) {
								vm.allProviders = response.data.data.allProviders;
							}
							eventBus.$emit('onLoaderFinish');
							vm.loaded = true;
						}
					})
					.catch(e => {
						eventBus.$emit('onLoaderFinish');
						vm.$toastr.error('Api ' + vm.tabName + ' tab load failed', 'Error');
					});
			},
		}
	}
</script>

<style scoped>

</style>
